import {
  Autocomplete,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useState } from "react";

const AddressForm = ({
  formik,
  dataSelection,
  dataArea,
  isLoadingArea,
  mutateArea,
}) => {
  const [isSameAddress, setIsSameAddress] = useState(true);

  return (
    <div>
      <p className="mb-2 font-bold">Alamat Sesuai KTP</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div className="w-full">
          <TextField
            fullWidth
            placeholder="Alamat Lengkap"
            label="Alamat Lengkap"
            value={formik.values.data.identity_address.address}
            onChange={(e) => {
              formik.setFieldValue(
                "data.identity_address.address",
                e.target.value
              );
              if (isSameAddress)
                formik.setFieldValue(
                  "data.domicile_address.address",
                  e.target.value
                );
            }}
          />
        </div>
        <div className="w-full">
          <TextField
            fullWidth
            placeholder="RT"
            label="RT"
            value={formik.values.data.identity_address.rt}
            onChange={(e) => {
              formik.setFieldValue(
                "data.identity_address.rt",
                Number(e.target.value)
              );
              if (isSameAddress && !isNaN(Number(e.target.value)))
                formik.setFieldValue(
                  "data.domicile_address.rt",
                  e.target.value
                );
            }}
          />
        </div>
        <div className="w-full">
          <TextField
            fullWidth
            placeholder="RW"
            label="RW"
            value={formik.values.data.identity_address.rw}
            onChange={(e) => {
              formik.setFieldValue(
                "data.identity_address.rw",
                Number(e.target.value)
              );
              if (isSameAddress)
                formik.setFieldValue(
                  "data.domicile_address.rw",
                  !isNaN(Number(e.target.value))
                );
            }}
          />
        </div>
        <div className="w-full">
          <Autocomplete
            autoComplete="off"
            disablePortal
            fullWidth
            onOpen={() => {
              mutateArea({
                province: "",
                city: "",
                district: "",
              });
            }}
            loading={isLoadingArea}
            options={dataArea && dataArea.province ? dataArea.province : []}
            value={
              dataArea &&
              dataArea.province &&
              formik.values.data.identity_address?.province !== ""
                ? dataArea.province.find(
                    (area) =>
                      area.province ===
                      formik.values.data.identity_address.province
                  )
                : null
            }
            sx={{ backgroundColor: "white" }}
            onChange={(_, inputValue) => {
              formik.setValues((prevVal) => ({
                ...prevVal,
                data: {
                  ...prevVal.data,
                  identity_address: {
                    ...prevVal.data.identity_address,
                    province: inputValue ? inputValue.province : "",
                    city: "",
                    district: "",
                    sub_district: "",
                  },
                  domicile_address: {
                    ...prevVal.data.domicile_address,
                    province: isSameAddress
                      ? inputValue
                        ? inputValue.province
                        : ""
                      : prevVal.data.domicile_address.province,
                    city: isSameAddress
                      ? ""
                      : prevVal.data.domicile_address.city,
                    district: isSameAddress
                      ? ""
                      : prevVal.data.domicile_address.district,
                    sub_district: isSameAddress
                      ? ""
                      : prevVal.data.domicile_address.sub_district,
                  },
                },
              }));
            }}
            getOptionLabel={(option) => option.province || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                placeholder="Provinsi"
                slotProps={{
                  input: {
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {isLoadingArea ? <CircularProgress size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  },
                }}
              />
            )}
          />
        </div>
        <div className="w-full">
          <Autocomplete
            autoComplete="off"
            disablePortal
            fullWidth
            disabled={formik.values.data.identity_address.province === ""}
            onOpen={() => {
              mutateArea({
                province: formik.values.data.identity_address.province,
                city: "",
                district: "",
              });
            }}
            loading={isLoadingArea}
            options={dataArea && dataArea.city ? dataArea.city : []}
            value={
              dataArea?.city && formik.values.data.identity_address?.city !== ""
                ? dataArea.city.find(
                    (area) =>
                      area.city === formik.values.data.identity_address.city
                  )
                : null
            }
            sx={{ backgroundColor: "white" }}
            onChange={(_, inputValue) => {
              formik.setValues((prevVal) => ({
                ...prevVal,
                data: {
                  ...prevVal.data,
                  identity_address: {
                    ...prevVal.data.identity_address,
                    city: inputValue ? inputValue.city : "",
                    district: "",
                    sub_district: "",
                  },
                  domicile_address: {
                    ...prevVal.data.domicile_address,

                    city: isSameAddress
                      ? inputValue
                        ? inputValue.city
                        : ""
                      : prevVal.data.domicile_address.city,
                    district: isSameAddress
                      ? ""
                      : prevVal.data.domicile_address.district,
                    sub_district: isSameAddress
                      ? ""
                      : prevVal.data.domicile_address.sub_district,
                  },
                },
              }));
            }}
            getOptionLabel={(option) => option.city || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                placeholder="Kota"
                slotProps={{
                  input: {
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {isLoadingArea ? <CircularProgress size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  },
                }}
              />
            )}
          />
        </div>
        <div className="w-full">
          <Autocomplete
            autoComplete="off"
            disablePortal
            fullWidth
            disabled={formik.values.data.identity_address.city === ""}
            onOpen={() => {
              mutateArea({
                province: formik.values.data.identity_address.province,
                city: formik.values.data.identity_address.city,
                district: "",
              });
            }}
            loading={isLoadingArea}
            options={dataArea && dataArea.district ? dataArea.district : []}
            value={
              dataArea?.district &&
              formik.values.data.identity_address?.district !== ""
                ? dataArea.district.find(
                    (area) =>
                      area.district ===
                      formik.values.data.identity_address.district
                  )
                : null
            }
            sx={{ backgroundColor: "white" }}
            onChange={(_, inputValue) => {
              formik.setValues((prevVal) => ({
                ...prevVal,
                data: {
                  ...prevVal.data,
                  identity_address: {
                    ...prevVal.data.identity_address,
                    district: inputValue ? inputValue.district : "",
                    sub_district: "",
                  },
                  domicile_address: {
                    ...prevVal.data.domicile_address,
                    district: isSameAddress
                      ? inputValue
                        ? inputValue.district
                        : ""
                      : prevVal.data.domicile_address.district,
                    sub_district: isSameAddress
                      ? ""
                      : prevVal.data.domicile_address.sub_district,
                  },
                },
              }));
            }}
            getOptionLabel={(option) => option.district || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                placeholder="Kecamatan"
                slotProps={{
                  input: {
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {isLoadingArea ? <CircularProgress size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  },
                }}
              />
            )}
          />
        </div>
        <div className="w-full">
          <Autocomplete
            autoComplete="off"
            disablePortal
            fullWidth
            disabled={formik.values.data.identity_address.district === ""}
            onOpen={() => {
              mutateArea({
                province: formik.values.data.identity_address.province,
                city: formik.values.data.identity_address.city,
                district: formik.values.data.identity_address.district,
              });
            }}
            loading={isLoadingArea}
            options={
              dataArea && dataArea.subdistrict ? dataArea.subdistrict : []
            }
            value={
              dataArea?.subdistrict &&
              formik.values.data.identity_address?.sub_district !== ""
                ? dataArea.subdistrict.find(
                    (area) =>
                      area.sub_district ===
                      formik.values.data.identity_address.sub_district
                  )
                : null
            }
            sx={{ backgroundColor: "white" }}
            onChange={(_, inputValue) => {
              formik.setValues((prevVal) => ({
                ...prevVal,
                data: {
                  ...prevVal.data,
                  identity_address: {
                    ...prevVal.data.identity_address,
                    sub_district: inputValue ? inputValue.sub_district : "",
                    postal_code: inputValue ? inputValue.post_code : "",
                  },
                  domicile_address: {
                    ...prevVal.data.domicile_address,
                    sub_district: isSameAddress
                      ? inputValue
                        ? inputValue.sub_district
                        : ""
                      : prevVal.data.domicile_address.sub_district,
                    postal_code: isSameAddress
                      ? inputValue
                        ? inputValue.post_code
                        : ""
                      : prevVal.data.domicile_address.postal_code,
                  },
                },
              }));
            }}
            getOptionLabel={(option) => option.sub_district || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                placeholder="Kelurahan/Desa"
                slotProps={{
                  input: {
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {isLoadingArea ? <CircularProgress size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  },
                }}
              />
            )}
          />
        </div>
        <div className="w-full">
          <TextField
            fullWidth
            placeholder="Kode Pos"
            label="Kode Pos"
            value={formik.values.data.identity_address.postal_code}
            onChange={(e) => {
              formik.setFieldValue(
                "data.identity_address.postal_code",
                e.target.value
              );
              if (isSameAddress)
                formik.setFieldValue(
                  "data.domicile_address.postal_code",
                  e.target.value
                );
            }}
          />
        </div>
      </div>

      <FormControlLabel
        checked={isSameAddress}
        onChange={(_, checked) => {
          setIsSameAddress(checked);
          formik.setValues({
            ...formik.values,
            data: {
              ...formik.values.data,
              domicile_address: {
                address: checked
                  ? formik.values.data.identity_address.address
                  : "",
                rt: checked ? formik.values.data.identity_address.rt : "",
                rw: checked ? formik.values.data.identity_address.rw : "",
                province: checked
                  ? formik.values.data.identity_address.province
                  : "",
                city: checked ? formik.values.data.identity_address.city : "",
                district: checked
                  ? formik.values.data.identity_address.district
                  : "",
                sub_district: checked
                  ? formik.values.data.identity_address.sub_district
                  : "",
                postal_code: checked
                  ? formik.values.data.identity_address.postal_code
                  : "",
              },
            },
          });
        }}
        control={<Checkbox value={isSameAddress} />}
        label="Sama dengan alamat domisili"
        sx={{ marginBottom: 2 }}
      />

      {isSameAddress ? null : (
        <>
          <hr className="mb-4" />
          <p className="mb-2 font-bold">Alamat Domisili</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div className="w-full">
              <TextField
                fullWidth
                placeholder="Alamat Lengkap"
                label="Alamat Lengkap"
                value={formik.values.data.domicile_address.address}
                onChange={(e) =>
                  formik.setFieldValue(
                    "data.domicile_address.address",
                    e.target.value
                  )
                }
              />
            </div>
            <div className="w-full">
              <TextField
                fullWidth
                placeholder="RT"
                label="RT"
                value={formik.values.data.domicile_address.rt}
                onChange={(e) =>
                  formik.setFieldValue(
                    "data.domicile_address.rt",
                    e.target.value
                  )
                }
              />
            </div>
            <div className="w-full">
              <TextField
                fullWidth
                placeholder="RW"
                label="RW"
                value={formik.values.data.domicile_address.rw}
                onChange={(e) =>
                  formik.setFieldValue(
                    "data.domicile_address.rw",
                    e.target.value
                  )
                }
              />
            </div>
            <div className="w-full">
              <Autocomplete
                autoComplete="off"
                disablePortal
                fullWidth
                onOpen={() => {
                  mutateArea({
                    province: "",
                    city: "",
                    district: "",
                  });
                }}
                loading={isLoadingArea}
                options={dataArea && dataArea.province ? dataArea.province : []}
                value={
                  dataArea &&
                  dataArea.province &&
                  formik.values.data.domicile_address?.province !== ""
                    ? dataArea.province.find(
                        (area) =>
                          area.province ===
                          formik.values.data.domicile_address.province
                      )
                    : null
                }
                sx={{ backgroundColor: "white" }}
                onChange={(_, inputValue) => {
                  formik.setValues((prevVal) => ({
                    ...prevVal,
                    data: {
                      ...prevVal.data,
                      domicile_address: {
                        ...prevVal.data.domicile_address,
                        province: inputValue ? inputValue.province : "",
                        city: "",
                        district: "",
                        sub_district: "",
                      },
                    },
                  }));
                }}
                getOptionLabel={(option) => option.province || ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    placeholder="Provinsi"
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {isLoadingArea ? (
                              <CircularProgress size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      },
                    }}
                  />
                )}
              />
            </div>
            <div className="w-full">
              <Autocomplete
                autoComplete="off"
                disablePortal
                fullWidth
                disabled={formik.values.data.domicile_address.province === ""}
                onOpen={() => {
                  mutateArea({
                    province: formik.values.data.domicile_address.province,
                    city: "",
                    district: "",
                  });
                }}
                loading={isLoadingArea}
                options={dataArea && dataArea.city ? dataArea.city : []}
                value={
                  dataArea?.city &&
                  formik.values.data.domicile_address?.city !== ""
                    ? dataArea.city.find(
                        (area) =>
                          area.city === formik.values.data.domicile_address.city
                      )
                    : null
                }
                sx={{ backgroundColor: "white" }}
                onChange={(_, inputValue) => {
                  formik.setValues((prevVal) => ({
                    ...prevVal,
                    data: {
                      ...prevVal.data,
                      domicile_address: {
                        ...prevVal.data.domicile_address,
                        city: inputValue ? inputValue.city : "",
                        district: "",
                        sub_district: "",
                      },
                    },
                  }));
                }}
                getOptionLabel={(option) => option.city || ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    placeholder="Kota"
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {isLoadingArea ? (
                              <CircularProgress size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      },
                    }}
                  />
                )}
              />
            </div>
            <div className="w-full">
              <Autocomplete
                autoComplete="off"
                disablePortal
                fullWidth
                disabled={formik.values.data.domicile_address.city === ""}
                onOpen={() => {
                  mutateArea({
                    province: formik.values.data.domicile_address.province,
                    city: formik.values.data.domicile_address.city,
                    district: "",
                  });
                }}
                loading={isLoadingArea}
                options={dataArea && dataArea.district ? dataArea.district : []}
                value={
                  dataArea?.district &&
                  formik.values.data.domicile_address?.district !== ""
                    ? dataArea.district.find(
                        (area) =>
                          area.district ===
                          formik.values.data.domicile_address.district
                      )
                    : null
                }
                sx={{ backgroundColor: "white" }}
                onChange={(_, inputValue) => {
                  formik.setValues((prevVal) => ({
                    ...prevVal,
                    data: {
                      ...prevVal.data,
                      domicile_address: {
                        ...prevVal.data.domicile_address,
                        district: inputValue ? inputValue.district : "",
                        sub_district: "",
                      },
                    },
                  }));
                }}
                getOptionLabel={(option) => option.district || ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    placeholder="Kecamatan"
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {isLoadingArea ? (
                              <CircularProgress size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      },
                    }}
                  />
                )}
              />
            </div>
            <div className="w-full">
              <Autocomplete
                autoComplete="off"
                disablePortal
                fullWidth
                disabled={formik.values.data.domicile_address.district === ""}
                onOpen={() => {
                  mutateArea({
                    province: formik.values.data.domicile_address.province,
                    city: formik.values.data.domicile_address.city,
                    district: formik.values.data.domicile_address.district,
                  });
                }}
                loading={isLoadingArea}
                options={
                  dataArea && dataArea.subdistrict ? dataArea.subdistrict : []
                }
                value={
                  dataArea?.subdistrict &&
                  formik.values.data.domicile_address?.sub_district !== ""
                    ? dataArea.subdistrict.find(
                        (area) =>
                          area.sub_district ===
                          formik.values.data.domicile_address.sub_district
                      )
                    : null
                }
                sx={{ backgroundColor: "white" }}
                onChange={(_, inputValue) => {
                  formik.setValues((prevVal) => ({
                    ...prevVal,
                    data: {
                      ...prevVal.data,
                      domicile_address: {
                        ...prevVal.data.domicile_address,
                        sub_district: inputValue ? inputValue.sub_district : "",
                        postal_code: inputValue ? inputValue.post_code : "",
                      },
                    },
                  }));
                }}
                getOptionLabel={(option) => option.sub_district || ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    placeholder="Kelurahan/Desa"
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {isLoadingArea ? (
                              <CircularProgress size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      },
                    }}
                  />
                )}
              />
            </div>
            <div className="w-full">
              <TextField
                fullWidth
                placeholder="Kode Pos"
                label="Kode Pos"
                value={formik.values.data.domicile_address.postal_code}
                onChange={(e) =>
                  formik.setFieldValue(
                    "data.domicile_address.postal_code",
                    e.target.value
                  )
                }
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AddressForm;
